module.exports = __webpack_public_path__ + "static/media/Mac Miller - Funeral.4880e9d0.mp3";